import {ActionType} from "typesafe-actions";
import IAnalyticsAction from "../IAnalyticsAction";
import {answerQuestion} from "../../../questions/actions";

export default function answerQuestionHandler({ payload }: ActionType<typeof answerQuestion>): IAnalyticsAction | undefined {
    if (payload.attempts > -1 && !payload.isRight)
        return;

    const action = payload.isRight
        ? "right"
        : "wrong";

    return {
        category: "question",
        object: "answer",
        name: action,
        postId: payload.questionId,
        levelId: payload.levelId,
    };
}